import { useQuery } from '@tanstack/react-query';
import { Link } from 'react-router-dom';

import { messageApi } from '@/api';
import { Icon } from '@/components/ui';

/**
 * The small messages icon beside the header bell, with the unread count. It
 * shares `UnreadBadge`'s query, so the socket keeps this count live too.
 */
export function HeaderMessagesLink({ to }) {
  const { data } = useQuery({
    queryKey: ['messages-unread'],
    queryFn: messageApi.getUnreadMessages,
    refetchInterval: 120_000,
  });
  const unread = data?.unread ?? 0;

  return (
    <Link
      to={to}
      aria-label={unread ? `Messages, ${unread} unread` : 'Messages'}
      title="Messages"
      className="text-ink-muted hover:bg-surface-muted hover:text-ink rounded-input relative flex size-9 items-center justify-center transition"
    >
      <Icon name="chat" size={18} />
      {unread > 0 && (
        <span className="bg-brand-600 absolute top-1 right-1 flex min-w-4 items-center justify-center rounded-full px-1 text-[10px] leading-4 font-medium text-white">
          {unread > 99 ? '99+' : unread}
        </span>
      )}
    </Link>
  );
}
